import script from "./odmCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./odmCarousel.vue?vue&type=script&setup=true&lang=js"

import "./odmCarousel.vue?vue&type=style&index=0&id=86055a98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86055a98"]])

export default __exports__